import { cn } from '@/lib/utils';

export function Spinner({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <span
      className={cn('inline-block border-2 border-current border-t-transparent rounded-full animate-spin text-blue-600', className)}
      style={{ width: size, height: size }}
      aria-label="Loading"
    />
  );
}

export function LoadingState({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex items-center justify-center py-12 text-gray-500 dark:text-gray-400">
      <Spinner />
      <span className="ml-3 text-sm">{label}</span>
    </div>
  );
}
